import React from "react";

const CheckoutSide = ({ color = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.93732 9.13172L11.944 6.12506L11.2811 5.46216L8.93732 7.80591L7.99982 6.86841L7.33691 7.53131L8.93732 9.13172Z"
        fill={color}
      />
      <path
        d="M12.6875 11.75H5.1875C4.92903 11.75 4.71875 11.5397 4.71875 11.2812C4.71875 11.0228 4.92903 10.8125 5.1875 10.8125H13.8536L16 3.3125H3.93891L3.7405 2.50675L3.74016 2.50684C3.58878 1.89366 3.03428 1.4375 2.375 1.4375H1.40625C0.630844 1.4375 0 2.06834 0 2.84375H0.9375C0.9375 2.58528 1.14778 2.375 1.40625 2.375H2.375C2.63347 2.375 2.84375 2.58528 2.84375 2.84375H2.858L4.619 9.9955C4.12606 10.2143 3.78125 10.7081 3.78125 11.2812C3.78125 12.0567 4.41209 12.6875 5.1875 12.6875H5.73688C5.68484 12.8342 5.65625 12.9919 5.65625 13.1562C5.65625 13.9317 6.28709 14.5625 7.0625 14.5625C7.83791 14.5625 8.46875 13.9317 8.46875 13.1562C8.46875 12.9919 8.44016 12.8342 8.38813 12.6875H11.3619C11.3099 12.8342 11.2813 12.9919 11.2813 13.1562C11.2813 13.9317 11.9121 14.5625 12.6875 14.5625C13.4629 14.5625 14.0938 13.9317 14.0938 13.1562C14.0938 12.3808 13.4629 11.75 12.6875 11.75ZM14.7572 4.25L13.1464 9.875H5.55484L4.16978 4.25H14.7572ZM7.53125 13.1562C7.53125 13.4147 7.32097 13.625 7.0625 13.625C6.80403 13.625 6.59375 13.4147 6.59375 13.1562C6.59375 12.8978 6.80403 12.6875 7.0625 12.6875C7.32097 12.6875 7.53125 12.8978 7.53125 13.1562ZM12.6875 13.625C12.429 13.625 12.2188 13.4147 12.2188 13.1562C12.2188 12.8978 12.429 12.6875 12.6875 12.6875C12.946 12.6875 13.1562 12.8978 13.1562 13.1562C13.1562 13.4147 12.946 13.625 12.6875 13.625Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckoutSide;
